import { Check, X } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";
import { Button } from "@/shared/ui/button";

interface BulkSelectionToolbarProps {
  selectedCount: number;
  allSelected: boolean;
  disabled?: boolean;
  onToggleAll: () => void;
  onClose: () => void;
  children: ReactNode;
}

export function BulkSelectionToolbar({
  selectedCount,
  allSelected,
  disabled = false,
  onToggleAll,
  onClose,
  children,
}: BulkSelectionToolbarProps) {
  return (
    <div className="grid h-14 grid-cols-[1fr_auto_1fr] items-center">
      <div className="flex h-full items-center gap-3 justify-self-start">
        <button
          type="button"
          onClick={onToggleAll}
          disabled={disabled}
          title={allSelected ? "取消全选" : "全选当前页"}
          className="inline-flex items-center text-sm text-muted-foreground transition-colors hover:text-foreground disabled:pointer-events-none disabled:opacity-50"
        >
          <span
            className={cn(
              "flex size-5 items-center justify-center rounded-md border-[1.5px] transition-colors",
              allSelected
                ? "border-primary bg-primary text-primary-foreground"
                : "border-border/70 bg-background text-transparent",
            )}
          >
            <Check className="size-3" strokeWidth={2.6} />
          </span>
        </button>

        <div className="text-sm font-medium text-foreground">
          已选择 <span className="tabular-nums">{selectedCount}</span> 项
        </div>
      </div>

      <div className="flex h-full items-center gap-5 justify-self-center">
        {children}
      </div>

      <div className="flex h-full items-center justify-self-end">
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={onClose}
          title="退出选择模式"
          className="size-7 text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <X className="size-4" />
        </Button>
      </div>
    </div>
  );
}
